import { Feature, FeatureCollection, Polygon } from 'geojson';
import transform from 'geojson-transformer';
import { fetchInspectionAreas } from '../../api/operation/polygon';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';

export default class InspectionAreasLoader extends SingletonEventEmitterClass {
  public geojson: FeatureCollection<Polygon> = {
    type: 'FeatureCollection',
    features: [],
  };

  public onMapLoad() {
    this._fetchData();
  }

  private _triggerUpdated() {
    this.emit('updated');
  }

  private _fetchData() {
    fetchInspectionAreas().then(({ data }) => {
      const { items } = data;
      this.geojson = {
        type: 'FeatureCollection',
        features: items.map<Feature<Polygon>>(polygon => {
          return {
            type: 'Feature',
            geometry: transform(polygon.path, 'gcj02', 'wgs84'),
            properties: {
              id: polygon._id,
              info: { ...polygon, layerType: 'inspectionArea' },
            },
          };
        }),
      };
      this._triggerUpdated();
    }).catch(error => {
      // noop.
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/InspectionAreasLoader.ts